import * as types from 'constants/actionTypes'
export const changeBodyDarkened = value => ({ type: types.CHANGE_EDITOR_POPOVER_VISIBILITY, value })



// WEBPACK FOOTER //
// ./src/actions/guiAC.js